import type { EulerRotation, Transform } from '@mindcloudxai/shared';
import { Quat, type Entity } from 'playcanvas';

function toDegrees(rad: number): number {
  return (rad * 180) / Math.PI;
}

export function rotationToQuat(rotation?: EulerRotation): Quat {
  return new Quat().setFromEulerAngles(
    toDegrees(rotation?.x ?? 0),
    toDegrees(rotation?.y ?? 0),
    toDegrees(rotation?.z ?? 0),
  );
}

/** 应用 splat entity 的场景级旋转与调用方 transform。 */
export function applyEntityTransform(
  entity: Entity,
  baseRotation?: EulerRotation,
  transform?: Transform,
): void {
  if (baseRotation || transform?.rotation) {
    const existing = new Quat().copy(entity.getLocalRotation());
    const base = rotationToQuat(baseRotation);
    const user = rotationToQuat(transform?.rotation);
    const composed = new Quat().mul2(existing, base).mul(user);
    entity.setLocalRotation(composed);
  }

  if (transform?.position) {
    entity.setLocalPosition(transform.position.x, transform.position.y, transform.position.z);
  }
  if (typeof transform?.scale === 'number') {
    entity.setLocalScale(transform.scale, transform.scale, transform.scale);
  } else if (transform?.scale) {
    entity.setLocalScale(transform.scale.x, transform.scale.y, transform.scale.z);
  }
}
